<template>
  <div class="basic_wrap user-page wallet-page">
    <header class="wallet-header">
      <button
        type="button"
        class="wallet-back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('moneybag.myWallet') }}</h1>
      <button
        type="button"
        class="wallet-history"
        aria-hidden="true"
      >
        <van-icon name="filter-o" />
      </button>
    </header>
    <main class="wallet-content">
      <section class="balance-card">
        <p class="balance-label">
          {{ $t('moneybag.accountBalance') }}
        </p>
        <p class="wallet-balance">
          {{ $formatPen(funds) }}
        </p>
        <div class="balance-meta">
          <div class="balance-stat">
            <span>{{ $t('user.availableBalance') }}</span>
            <strong>{{ $formatPen(mymoney) }}</strong>
          </div>
          <div class="balance-stat">
            <span>{{ $t('shop.frozenAmount') }}</span>
            <strong>{{ $formatPen(frozen) }}</strong>
          </div>
        </div>
      </section>

      <van-empty
        v-if="listShow"
        class="wallet-empty"
        :description="$t('moneybag.detailsEmpty')"
      />
      <section
        v-else-if="data"
        class="detail_box activity-card"
      >
        <div
          v-for="item in visibleTransactions"
          :key="item.id"
          class="item"
        >
          <div class="de_wrap">
            <p class="tit">
              {{ item[lang] }}
            </p>
            <p class="time">
              {{ formatTime(item.time) }}
            </p>
          </div>
          <div
            class="price"
            :class="{ del: item.type != '1' }"
          >
            {{ item.type == '1' ? $formatPen(item.money) : '-' + $formatPen(item.money) }}
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "Moneybag",
        data() {
            return {
                lang: this.$i18n.locale || "zh_cn",
                data: null,
                list: {},
                account: 0,
                option: [],
                listShow: false,
                funds: 0,
                frozen: 0,
                mymoney: 0,
                userName: ''
            };
        },
        computed: {
            visibleTransactions() {
                return (this.data || []).filter((item) => Number(item.show) === 1);
            }
        },
        created() {
            this.$parent.footer('user');
        },
        mounted() {
            Fetch('/user/funds').then((r) => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                });
                for (const reasonId in r.data.reason) {
                    switch (reasonId) {
                        case "1":
                            r.data.reason[reasonId] = this.$t('moneybag.recharge');
                            break;
                        case "2":
                            r.data.reason[reasonId] = this.$t('moneybag.withdraw');
                            break;
                        case "3":
                            r.data.reason[reasonId] = this.$t('moneybag.give');
                            break;
                        case "4":
                            r.data.reason[reasonId] = this.$t('moneybag.signIn');
                            break;
                        case "5":
                            r.data.reason[reasonId] = this.$t('moneybag.share');
                            break;
                        case "6":
                            r.data.reason[reasonId] = this.$t('moneybag.purchase');
                            break;
                        case "7":
                            r.data.reason[reasonId] = this.$t('moneybag.redPacket');
                            break;
                        case "8":
                            r.data.reason[reasonId] = this.$t('moneybag.reward');
                            break;
                        case "9":
                            r.data.reason[reasonId] = this.$t('moneybag.welfare');
                            break;
                        case "10":
                            r.data.reason[reasonId] = this.$t('moneybag.invite');
                            break;
                        case "11":
                        case "12":
                            r.data.reason[reasonId] = this.$t('moneybag.income');
                            break;
                        default:
                            break;
                    }
                    this.option.push({
                        text: r.data.reason[reasonId],
                        value: reasonId
                    });
                }

                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = 1 * r.data.money + 1 * r.data.wx_bankbz;
                this.mymoney = r.data.mymoney;
                this.frozen = r.data.frozenmoney || 0;
                this.userName = r.data.username;
                this.listd(1);
            });
        },
        methods: {
            formatTime(value) {
                if (value === null || value === undefined || value === '') return '--';
                let timestamp = value;
                if (/^\d+$/.test(String(value))) {
                    timestamp = Number(value);
                    if (timestamp < 100000000000) timestamp *= 1000;
                }
                const date = new Date(timestamp);
                if (Number.isNaN(date.getTime())) return String(value);
                const pad = (number) => String(number).padStart(2, '0');
                return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
            },
            listd(type) {
                const dataf = this.data;
                this.data = null;
                if (dataf && dataf.length > 0) {
                    dataf.forEach((item) => {
                        const isReward = Number(item.reason_type) === 3 || Number(item.reason_type) === 4;
                        item.show = type === 1 || (type === 2 && !isReward) || (type !== 1 && type !== 2 && isReward) ? 1 : 0;
                    });
                }
                this.data = dataf;
            },
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .wallet-page {
        min-height: 100vh;
        box-sizing: border-box;
        padding-bottom: calc(var(--app-bottom-menu-height) + 24px + env(safe-area-inset-bottom, 0px));
        background: #f5f6f8;
        color: #17243a;
    }

    .wallet-header {
        position: relative;
        display: flex;
        height: 50px;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #edf0f3;
        background: #fff;

        h1 {
            margin: 0;
            color: #17243a;
            font-size: 15px;
            font-weight: 600;
            line-height: 20px;
        }
    }

    .wallet-back,
    .wallet-history {
        position: absolute;
        top: 0;
        display: inline-flex;
        width: 50px;
        height: 50px;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: 0;
        background: transparent;
        color: #17243a;
        font-size: 20px;
    }

    .wallet-back { left: 0; justify-content: flex-start; padding-left: 16px; }
    .wallet-history { right: 0; font-size: 18px; }

    .wallet-content { padding: 16px; }

    .balance-card {
        min-height: 140px;
        box-sizing: border-box;
        padding: 22px 20px 17px;
        border-radius: 10px;
        background: #ee4d2d;
        box-shadow: 0 6px 18px rgba(238, 77, 45, .16);
    }

    .balance-label {
        margin: 0 0 8px;
        color: rgba(255, 255, 255, .84);
        font-size: 13px;
        line-height: 18px;
    }

    .wallet-balance {
        margin: 0;
        overflow: hidden;
        color: #fff;
        font-size: 28px;
        font-weight: 700;
        line-height: 38px;
        letter-spacing: -.4px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .balance-meta {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px solid rgba(255, 255, 255, .28);
        color: rgba(255, 255, 255, .8);
        font-size: 12px;
        line-height: 17px;

        .balance-stat {
            min-width: 0;

            + .balance-stat {
                padding-left: 16px;
                border-left: 1px solid rgba(255, 255, 255, .28);
            }
        }

        span,
        strong {
            display: block;
        }

        strong {
            margin-top: 4px;
            overflow: hidden;
            color: #fff;
            font-weight: 500;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .wallet-empty {
        margin-top: 16px;
        border-radius: 10px;
        background: #fff;
    }

    .activity-card {
        margin-top: 16px;
        overflow: hidden;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 6px 18px rgba(23, 36, 58, .04);
    }

    .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        min-height: 66px;
        padding: 14px 18px;
        border-bottom: 1px solid #edf0f3;

        &:last-child { border-bottom: 0; }
    }

    .de_wrap { min-width: 0; flex: 1; }

    .tit {
        margin: 0;
        overflow: hidden;
        color: #27384f;
        font-size: 13px;
        font-weight: 600;
        line-height: 19px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .time {
        margin: 5px 0 0;
        overflow: hidden;
        color: #8792a3;
        font-size: 11px;
        line-height: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .price {
        flex: 0 0 auto;
        max-width: 42%;
        overflow: hidden;
        color: #17243a;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        text-align: right;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.del { color: #239466; }
    }
</style>
